"use client";

import { useCallback, useEffect, useState } from "react";
export function useProduct(handle) {
  const [productLoading, setLoading] = useState(false);
  const [productReviews, setProductReviews] = useState({});
  const [error, setError] = useState(null);
  const fetchReviews = useCallback(async () => {
    if (!handle) return;
    setLoading(true);
    try {
      const resp = await fetch(`/api/products/${handle}/reviews`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        }
      });
      const data = await resp.json();
      setProductReviews(data);
      setError(null);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [handle]);
  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    fetchReviews();
  }, [fetchReviews]);
  return {
    productReviews,
    productLoading,
    error,
    refetchReviews: fetchReviews
  };
}